import { Modal } from '@bp/ui-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SubmissionAnswerForm } from '../forms/SubmissionAnswerForm';

type SubmissionAnswerModalProps = {
  submissionUuid: string;
  isOpen: boolean;
  onClose: () => void;
};

export const SubmissionAnswerModal = ({ submissionUuid, isOpen, onClose }: SubmissionAnswerModalProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Modal isOpen={isOpen} loading={loading} title={t('submissions.myAnswer')} onRequestClose={() => onClose()}>
      <SubmissionAnswerForm
        submissionUuid={submissionUuid}
        onLoad={(loading) => setLoading(loading)}
        onClose={() => onClose()}
      />
    </Modal>
  );
};
